export const MARKETPLACE_LOGIN_JOIN_US_SUBMIT = 'MARKETPLACE_LOGIN_JOIN_US_SUBMIT';


export function marketplaceLoginJoinUsSubmit(payload) {
  return {
    type: MARKETPLACE_LOGIN_JOIN_US_SUBMIT,
    payload,
  };
}
